export default "__VITE_ASSET__DCxOinxa__"